import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ic-google.svg'


const _withScopeId = n => (_pushScopeId("data-v-6746ee68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-0 d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Google",
  class: "button-logo"
}, null, -1))
const _hoisted_3 = { class: "ms-3 fs-7 text-black" }

import { translate } from '@/languages/i18n'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  theme: {
    type: String as PropType<'light' | 'neutral'>,
    default: 'light',
  },
  arrangement: {
    type: String as PropType<'vertical' | 'horizontal'>,
    default: 'vertical',
  },
  text: {
    type: String as PropType<'login' | 'integrate'>,
    default: 'login',
  },
  enabled: {
    type: Boolean,
    default: true,
  },
  onButtonClick: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onButtonClick && __props.onButtonClick(...args))),
      class: _normalizeClass([
        'p-2 button-container d-flex align-items-center rounded-3',
        __props.theme === 'light' ? 'bg-white' : 'bg-gray',
        __props.arrangement === 'horizontal' ? 'me-1' : '',
        !__props.enabled ? 'pe-none' : '',
      ])
    }, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.text === 'login' ? _unref(translate)('loginWithGoogle') : _unref(translate)('integrateWithGoogle')), 1)
    ], 2)
  ]))
}
}

})